import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/database';

const config = {
  apiKey: 'AIzaSyDLTMSfgMyl6REo6Bm2-0hIdXfGS1vl2b8',
  authDomain: 'gpr-demo-ebeda.firebaseapp.com',
  databaseURL: 'https://gpr-demo-ebeda-default-rtdb.firebaseio.com/',
  projectId: 'gpr-demo-ebeda',
  storageBucket: 'gpr-demo-ebeda.firebasestorage.app',
  messagingSenderId: '615908877439',
  appId: '1:615908877439:web:bd579d1368dd2402648b4a'
};

const fire = firebase.initializeApp(config);
export default fire;
